var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "350 100 694.024 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.646,133.88h22.471v49.227h30.088v17.424h-52.559v-76.65Z",
    fill: "#676bb2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M453.621,133.88h22.471v66.65h-22.471v-66.65Z",
    fill: "#676bb2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M567.875,133.88v66.65h-18.471l-25.328-30.278v30.278h-21.898v-66.65h18.471l25.328,30.278v-30.278h21.898Z",
    fill: "#676bb2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M649.371,183.582v16.948h-55.414v-66.65h54.177v16.948h-32.087v7.808h28.184v16.187h-28.184v8.76h33.324Z",
    fill: "#676bb2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M673.264,133.88h32.85c22.28,0,37.609,12.664,37.609,33.325s-15.329,33.325-37.609,33.325h-32.85v-66.65ZM705.161,183.011c9.427,0,15.901-5.617,15.901-15.806s-6.475-15.806-15.901-15.806h-9.427v31.611h9.427Z",
    fill: "#676bb2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M822.555,183.582v16.948h-55.416v-66.65h54.178v16.948h-32.088v7.808h28.184v16.187h-28.184v8.76h33.326Z",
    fill: "#676bb2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M842.258,195.198l7.236-16.377c6.283,3.713,14.662,6.094,21.994,6.094,6.379,0,8.664-1.333,8.664-3.618,0-8.379-36.848-1.618-36.848-26.47,0-12.378,10.379-22.471,31.04-22.471,8.95,0,18.187,1.904,25.137,5.809l-6.761,16.281c-6.569-3.332-12.758-4.951-18.566-4.951-6.57,0-8.664,1.904-8.664,4.189,0,7.998,36.848,1.333,36.848,25.898,0,12.188-10.379,22.471-31.04,22.471-11.14,0-22.376-2.762-29.04-6.855Z",
    fill: "#676bb2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M951.368,178.44l-5.046,5.617v16.473h-22.09v-66.65h22.09v24.185l21.898-24.185h24.471l-26.66,29.326,27.993,37.324h-25.993l-16.663-22.09Z",
    fill: "#676bb2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/Logo_text.452b2ce8d0e894ae3a245af7dc49d3fe.svg";
export { ForwardRef as ReactComponent };